import {
  BaseBusinessData,
  GetOutputForecastForReceiptResponseResult,
} from '@/coreInfrastructureModule/axios/generated/forecastForReceiptManage/api';
import {
  OutputForecastForReceiptBusinessData,
  OutputForecastForReceiptExcelData,
  OutputForecastForReceiptExcelInputInfo,
} from '../domains/entities/forecastForReceiptResponse';
import { convertBase64ToExcelBlob } from '@/appLogic/blobEncoder';

/**
 * 受領用内示エクセルテンプレートとエクセルに書き込む情報を取得するアダプタ
 */
export class GetOutputForecastForReceiptExcelDataAdapter {
  /**
   * responseをUI用に変換する
   * @param response - レスポンス
   */
  public static async adaptForResponse(response: GetOutputForecastForReceiptResponseResult): Promise<OutputForecastForReceiptExcelData> {
    try {
      const blob = await convertBase64ToExcelBlob(response.data.excelFile);

      // {[key: string]: {'baseBusinessList': BaseBusinessData[], 'outputRange': number}} を {[key: string]: {'baseBusinessList': IBusiness[], 'outputRange': number}} の形に変換する
      const excelInputInfo: { [key: string]: OutputForecastForReceiptExcelInputInfo } = {};
      for (const key in response.data.baseBusinesses) {
        if (response.data.baseBusinesses[key] !== null) {
          // 初期化
          if (!excelInputInfo[key]) {
            excelInputInfo[key] = { baseBusinessList: [], outputRange: 0 };
          }
          excelInputInfo[key].baseBusinessList = response.data.baseBusinesses[key].baseBusinessList.map(
            (business: BaseBusinessData): OutputForecastForReceiptBusinessData => ({
              warehouse: business.warehouse,
              warehouseNumber: business.warehouseNumber,
              businessNumber: business.businessNumber,
              businessName: business.businessName,
              supplierNumber: business.supplierNumber,
              supplierName: business.supplierName,
              package: business.package,
              salesDestinationName: business.salesDestinationName,
              salesDestinationNumber: business.salesDestinationNumber,
              customerName: business.customerName,
              customerNumber: business.customerNumber,
              forecastForReceiptMemo: business.forecastForReceiptMemo,
            })
          );
          excelInputInfo[key].outputRange = response.data.baseBusinesses[key].outputRange;
        }
      }

      return {
        templateForecastForReceiptExcelData: blob,
        excelInputInfo: excelInputInfo,
      };
    } catch (error) {
      throw new Error('Base64からExcelファイルの変換に失敗しました');
    }
  }
}
